import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Modal } from '@grandvisionhq/common';

var PopupModal = (_param)=> {
    var { className , children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "children"
    ]);
    return React.createElement(Modal, swcHelpers.extends({}, rest, {
        className: classnames('popup-modal', className)
    }), children);
};
var PopupModal$1 = PopupModal;

export { PopupModal, PopupModal$1 as default };
//# sourceMappingURL=PopupModal.js.map
